module.exports = __webpack_public_path__ + "static/media/Sketches-7.68fe9642.jpg";